module.exports = __webpack_public_path__ + "static/media/pdf.df66d865.svg";